export default "__VITE_PUBLIC_ASSET__d32e97a0__"